import { Consolidation } from '../types/ConsolidationTypes';
import { Amount, Tenor } from '../types/OfferTypes';
import { apiClient } from './apiClient';

export type SummaryResponse = {
    amount: Amount;
    tenor: Tenor;
    monthlyCost: Amount;
    isConsolidation: boolean;
    selectedConsolidations?: Consolidation[];
};

export const getSummaryService = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string | undefined,
): Promise<SummaryResponse> => {
    return apiClient<SummaryResponse>(`${proxyBaseUrl}/application/${arn}/summary`, {
        method: 'GET',
        apiKey,
        sentryTag: 'get_summary',
        sentryExtra: { arn },
    });
};
